import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nnzc8s53xn: FaireBrandEntity = {
  token: "b_nnzc8s53xn",
  type: "brand",
  name: "Juniper Wish",
  avatarUrl:
    "https://cdn.faire.com/fastly/54230b6d68cc63d4757ec6289eca520276397c9ca9c8a9b9c2f0def41705c3d2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/41633577f701dce933c8a7501d0aa94e8caed24f5d94f839e76be1c385ede240.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/54230b6d68cc63d4757ec6289eca520276397c9ca9c8a9b9c2f0def41705c3d2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/41633577f701dce933c8a7501d0aa94e8caed24f5d94f839e76be1c385ede240.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 9,
  isInsider: false,
  description:
    "Discover Juniper Wish, a Vancouver-based family-owned brand where timeless sophistication merges with exceptional craftsmanship. Our curated collection celebrates femininity and grace, offering delicate necklaces and intricately designed earrings. Blending classic elements with modern sensibilities, our empowering designs make each piece a cherished part of your journey. With a commitment to quality and a personal touch, Juniper Wish elevates your style, making wishes come true through exquisite women's fashion jewelry.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:45.042Z",
    importedBy: "entity-db-cli",
  },
};
